/**
 * Scrolls the page's own scroll area (the shell's .content) so `el` sits 16px
 * from its top. Not scrollIntoView: that also scrolls the document behind the
 * fixed top bar (overflow hidden, but still scrollable by script), which slid
 * the whole page up under the bar and hid the card's title.
 */
export function scrollToTop(el: HTMLElement) {
  let box: HTMLElement | null = el.parentElement;
  while (box && !/(auto|scroll)/.test(getComputedStyle(box).overflowY)) box = box.parentElement;
  const scroller = box ?? (document.scrollingElement as HTMLElement);
  const top = el.getBoundingClientRect().top - (box ? box.getBoundingClientRect().top : 0);
  scroller.scrollTo({ top: scroller.scrollTop + top - 16, behavior: 'smooth' });
}
